<template>
  <div>
    <b-navbar type="dark" variant="dark">
      <b-navbar-brand href="/#/home">
        <img :src="logo" class="d-inline-block align-top" alt="">
      </b-navbar-brand>

      <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

      <b-collapse id="nav-collapse" is-nav>
        <b-navbar-nav class="d-none"> <!-- not displaying -->
          <b-nav-item class="app-nav-link" href="/#/home" :active='$route.path ==="/home"'>Home</b-nav-item>
          <b-nav-item class="app-nav-link" href="/#/account" :active='$route.path ==="/account"'>Account</b-nav-item>
        </b-navbar-nav>

        <!-- Right aligned nav items -->
        <b-navbar-nav class="ml-auto">
          <locale-dropdown />
          <b-nav-item-dropdown right>
            <!-- Using 'button-content' slot -->
            <template #button-content>
              <i class="fa fa-user-circle"></i> {{ $store.state.account.data.displayName }}
            </template>
            <b-dropdown-item href="#" @click.prevent="logout">{{ $t('Logout') }}</b-dropdown-item>
          </b-nav-item-dropdown>
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>
    <div :class="klass">
      <div class="row">
        <div class="col col-12">
          <!-- Content will be placed here -->
          <slot />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* ============
 * Default Layout
 * ============
 *
 * Used for the home and account pages.
 *
 * Layouts are used to store a lot of shared code.
 * This way the app stays clean.
 */

import logo from '../../public/img/logo-small.png';
import LocaleDropdown from '@/components/LocaleDropdown';

export default {
  /**
   * The name of the layout.
   */
  name: 'DefaultLayout',

  components: {
    LocaleDropdown,
  },

  props: {
    klass: {
      type: String,
      default: 'container-fluid',
    },

  },

  /**
   * The data that can be used by the page.
   *
   * @returns {Object} The view-model data.
   */
  data() {
    return {
      menuCollapsed: false,
      logo
    };
  },

  mounted() {
    //console.log("Layout mounted", this);
  },

  /**
   * The methods that the layout can use.
   */
  methods: {
    /**
     * Will log the user out.
     */
    logout() {
      this.$store.dispatch('auth/logout');
    },

    /**
     * Will toggle the menu.
     */
    toggleMenu() {
      this.menuCollapsed = !this.menuCollapsed;
    },
  },
};
</script>
